// extracted by mini-css-extract-plugin
module.exports = {"meals":"AvailableMeal_meals__2Ubnv","meals-appear":"AvailableMeal_meals-appear__3eQBq"};